module.exports = __webpack_public_path__ + "static/img/logo_2_black323.b7986be.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo_2_black323.png
// module id = yVuG
// module chunks = 26